import React from 'react';
import { ChakraProvider, Box, Grid, Image, Heading, Text, useColorModeValue } from '@chakra-ui/react';
import TopBar from './components/Footer';
import NavigationHeader from './components/NavigationHeader';
import FooterBar from './components/GetAQuote';
import theme from "./theme"
import TopHeaderBar from './components/Top';
import Garrett from "./images/team/Garrett.png"
import Grace from "./images/team/Grace.png"
import Kyle from "./images/team/Kyle.png"
import Jacky from "./images/team/Jacky.png"
import Banner from "./pages/Personal-Insurance/Banner"
import PartnersPic from "./images/misc/Partners.jpeg"
import Ryan from "./images/team/Ryan.png"
import Matt from "./images/team/Matt.png"
import Christopher from "./images/team/Christopher.png"
import Maureen from "./images/team/Maureen.png"
import Ted from "./images/team/Ted.png"
import Amy from "./images/team/Amy.png"
import Victoria from "./images/team/Victoria.png"






function OurTeam() {
  const bgColor = useColorModeValue('gray.50', 'gray.900');
  const teamMembers = [
    {
      picture: Ryan,
      name: 'Ryan McDermott',
      title: 'Director of Insurance',
      description: 'Ryan is a graduate of Siena College where he studied Finance.  After college he moved to New York City where he began his insurance career and eventually relocated back to the Capital Region.  He enjoys traveling and being outdoors with his fiancé and watching his two stepsons play basketball.   Ryan is a huge Buffalo sports fan and is passionate about local sports, mainly RPI hockey and Siena basketball.  In his spare time you will likely find Ryan on the golf course.'
    },
       {
      picture: Kyle,
      name: 'Kyle Leonard',
      title: 'Business Development Manager',
      description: 'Kyle studied chemistry at SUNY Plattsburgh before starting his insurance career in 2014, working with businesses to enhance their employee benefits. After a few years, he expanded to helping customers with their car, home, and business insurance. In his free time, he enjoys tracking the stock market, watching TV shows, gardening, and spending time with his Mini Dachshund Oppie.'
    },
    {
      picture: Jacky,
      name: 'Jacky Torrisi',
      title: 'Team Leader - Sales',
      description: 'Jacky is a graduate of RPI, where she majored in Electronic Media, Art and Communications. She is an avid nature-lover and enjoys outdoor activities such as hiking, camping and paddleboarding. She is passionate about making art and playing music in her spare time. Jacky appreciates meeting new people and takes pride in helping others.'
    },
    {
      picture: Garrett,
      name: 'Garrett Langille',
      title: 'Senior Account Manager',
      description: 'Garrett has been selling and servicing insurance products for the last 7 years. He was raised in the Capital Region and enjoys playing sports and watching basketball and football games. He is an avid Dallas Cowboys and Los Angeles Lakers fan. His favorite thing is to help people resolve complicated issues.'
    },
    {
      picture: Grace,
      name: 'Grace DePietro',
      title: 'Sales Agent',
      description: 'Grace is a recent graduate of SUNY Oswego where she studied Communication and Social Interaction. She is a huge New York Yankee fan and enjoys traveling to different sporting events. She also has a love for dogs especially her best friend, 2-year-old Koda. She now resides in Amsterdam, NY after living in the Utica area her whole life.'
    },
    {
      picture: Christopher,
      name: 'Christopher White',
      title: 'Sales Agent',
      description: 'Christopher has a strong customer service background with an emphasis on listening to the concerns of each person he meets. He was born and raised in the Capital Region and currently resides in Albany. He enjoys fitness activities, spending time with his family pets, and going to concerts. He looks forward to assisting everyone with their insurance needs!'
    },
    {
      picture: Matt,
      name: 'Matthew Martini',
      title: 'Administrative Assistant',
      description: 'Matt is a recent graduate of SUNY Geneseo where he studied Communication. He is a large reading and writing fan, and spends as much time as he can in the outdoors through camping and hiking. He loves to explore and is planning to visit every continent in the world as soon as he can. His favorite activity is learning about all sorts of new things to better help people and understand the natural world.'
    },
      {
      picture: Maureen,
      name: 'Maureen Spaschak',
      title: 'Client Outreach Specialist',
      description: 'Maureen is a dedicated customer service professional with 15 years of experience helping customers and building strong relationships through excellent communication and problem-solving skills. She takes pride in creating positive experiences and making others days a little brighter. Originally from the Capital Region, she also spent much of her youth on the Gulf Coast. Maureen enjoys spending time in nature and has a deep love for her family and animals. Her passion for helping others, combined with her warm and approachable personality, shines through both her professional and personal life.'
    },
{
      picture: Ted,
      name: 'Ted Hollander',
      title: 'Sales Agent',
      description: 'Ted has been a Sales agent in the insurance industry for over 6 years. He was born and raised in Long Island, New York. He enjoys spending time with Friends, watching sports, and staying active. His knowledge of the market helps provide customers with the best coverage to fit their current needs and budget.'
    },
    {
      picture: Amy,
      name: 'Amy LaCroix',
      title: 'Health & Benefits Consultant',
      description: 'Amy has spent over 20 years in the employee and individual benefits industry and still loves what she does every single day. Helping people find the right coverage and making the process feel simple and stress-free is what drives her.  When she’s not helping clients, you’ll find her out on the water paddleboarding, catching live music and attending festivals (huge moe. and Umphreys McGee fan!), or cheering on the Buffalo Bills — Super Bowl, here we come! Most of all, she just loves spending time with family and friends and bringing a whole lot of laughter to everything she does.'
    },
    {
      picture: Victoria,
      name: 'Victoria South',
      title: 'Account Manager',
      description: 'A lifelong Capital Region resident with over 25 years of experience in client relations and customer service. Passionate about building connections and delivering exceptional service tailored to each clients needs and establishing lasting relationships throughout her career. Outside of her professional life, Vickie enjoys cooking and listening to music and spending quality time with family at the lake and making the most of every sunny day!'
    },
    
  ];
  

  return (
    <ChakraProvider theme={theme}>
      <Box 
        bg={"gray.100"}
        mx="auto"
        mb={16} 
        overflowX={"hidden"}
        paddingTop={"174px"}
      >
        <TopHeaderBar />
        <NavigationHeader />
        <Banner header={"Meet our Team"} img={PartnersPic}/>
        <Grid 
  templateColumns={{
    base: "repeat(1, minmax(0, 1fr))",
    md:   "repeat(2, minmax(0, 1fr))",
    lg:   "repeat(3, minmax(0, 1fr))",
    xl:   "repeat(4, minmax(0, 1fr))",
  }}
  gap={6} 
  padding={6} 
  justifyItems="center"
>
          {teamMembers.map((member, index) => (
            <Box 
  key={index} 
  w="100%"
  maxW="sm"
  borderWidth="1px" 
  borderRadius="lg" 
  overflow="hidden"
  boxShadow="2xl"  
  bg={bgColor}
  transition="0.3s"
  _hover={{ transform: "scale(1.02)", boxShadow: "xl" }}
>
              <Image borderRadius="md" src={member.picture} alt={member.name} />

              <Box p="6">
                <Box d="flex" alignItems="baseline">
                  <Heading fontFamily={"Avenir"} size="lg" fontWeight="semibold" lineHeight="tight" isTruncated color="purple.500">
                    {member.name}
                  </Heading>
                </Box>

                <Box mt={2} color="gray.600">
                  <Text fontSize="xl" fontWeight="bold">
                    {member.title}
                  </Text>
                  <Text mt={2}>
                    {member.description}
                  </Text>
                </Box>
              </Box>
            </Box>
          ))}
        </Grid>
        <FooterBar/>
        <TopBar/>
      </Box>
    </ChakraProvider>
  );

}

export default OurTeam;
